module.exports = __webpack_public_path__ + "static/media/road-show-3.d19822ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/RoadShowPage/assets/road-show-3.png
// module id = 540
// module chunks = 0